import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EmberObject, { action } from '@ember/object';
import { A } from '@ember/array';

import { FeedTypes } from 'mewe/constants';
import Storage from 'mewe/shared/storage';
import { localCopy } from 'tracked-toolbox';

export default class MwFeedFilter extends Component {
  @service settings;
  @service dynamicDialogs;
  @service features;

  feedTypes = FeedTypes;

  @localCopy('args.scope', FeedTypes.ALL)
  scope;

  get feeds() {
    let feeds = A([
      EmberObject.create({
        name: __('All'),
        scope: FeedTypes.ALL,
        visible: true,
      }),
      EmberObject.create({
        name: __('Following'),
        scope: FeedTypes.CONTACTS,
        visible: true,
      }),
      EmberObject.create({
        name: __('Discover'),
        scope: FeedTypes.DISCOVER,
        visible: true,
      }),
    ]);

    return feeds.filter((feed) => feed.visible);
  }

  get selectedFeed() {
    return this.feeds.find((f) => f.scope === this.scope);
  }

  get contactObject() {
    return this.feeds.find((f) => f.scope === FeedTypes.CONTACTS);
  }

  @action
  setFeedScope(feedType) {
    // get last state of filter from storage, we want to keep it for CONTACTS feed after switching feeds
    let feedParams = {
      scope: feedType.scope,
      filter: null,
    };

    if (feedType.scope === this.feedTypes.CONTACTS && Storage.get(Storage.keys.filterFavoritesInContacts)) {
      feedParams.filter = this.feedTypes.FAVORITES;
    }

    this.args.setFeedParams(feedParams);
  }

  @action
  setFeedFilter() {
    // toggle filter values {this.feedTypes.FAVORITES | null}
    Storage.set(Storage.keys.filterFavoritesInContacts, !this.args.filter);
    this.args.setFeedParams({ filter: this.args.filter ? null : this.feedTypes.FAVORITES });
  }
}
